import React from 'react';
import styles from './Modals.GenericModal.module.scss';

export class MainAppGenericModal extends React.Component {
    render() {
        const {
            title,
            open,
            content,
            handleClose,
            classContainer = "",
            classModalContainer = ""
        } = this.props;
        return (
            <div
                className={`
                    ${styles["main-app-generic-modal-container"]}
                    ${classContainer}
                    ${open ? styles["enabled-pointer-events"] : ""}
                `}
            >
                {open &&
                    <div className={styles["main-app-generic-modal-wrapper"]}>
                        <div className={styles["main-app-generic-modal-overlay"]} onClick={handleClose} data-automation-id="modal-overlay"></div>
                            <div
                            className={`
                                ${styles["main-app-generic-modal-modal-container"]}
                                ${classModalContainer}
                            `}
                            >
                            {title && <h1 className={styles["main-app-generic-modal-title"]}> {title} </h1>}
                            {content}
                        </div>
                    </div>
                }
            </div>
        )
    }

}


MainAppGenericModal.propTypes = {

};

export default MainAppGenericModal;